import React from 'react';
import Link from 'components/Link';
import LinkConstants from 'constants/LinkConstants';
import Text from 'components/Text';

export type Props = {
  purchaseForConnectedChild?: boolean;
  eventKey?: string;
  isStudent: boolean;
};

export default function TutoringSelfServeViewBillingLegalText(props: Props) {
  const { purchaseForConnectedChild, eventKey, isStudent } = props;
  let extraProps = {};
  if (eventKey) {
    extraProps = { ...extraProps, eventKey };
  }
  if (purchaseForConnectedChild) {
    return (
      <Text size="xsmall" color="graphite">
        By clicking "Confirm", you consent for your child to use Remind for the purpose of
        Remind Tutoring.
      </Text>
    );
  }
  return (
    <Text data-test="billing-legal-text" size="xsmall" color="graphite">
      By clicking "Confirm", you consent {isStudent ? '' : 'for your child'} to use Remind
      for the purpose of Remind Tutoring. We collect {isStudent ? 'your' : 'their'} name, subject of
      interest, session audio/video, and computer session information for quality and safety
      purposes. Remind never sells or shares this information. View our{' '}
      <Link
        {...extraProps}
        href={LinkConstants.PRIVACY_POLICY}
        target="_blank"
        underline
        weight="semibold"
        color="ink">
        Privacy Policy.
      </Link>
    </Text>
  );
}
